<template>
  <div class="content">
    <div class="row">
      <div class="col-md-3">
        <ArtistSelect
          @memberChangeEvent="getArtistInfo"
          :show-all-units="true"
          :is-filter="true"
          :show-members="false"
          :initial-unit-id="parseInt($route.query.unitId, 10)"
        />
      </div>
      <div class="col-md-3">
        <h4 class="card-title text-left">구분</h4>
        <div class="row">
          <el-select class="col-md-12 select-primary" size="large" placeholder="구분" v-model="searchType">
            <el-option v-for="option in searchOptions" class="select-primary" :value="option.value" :label="option.label" :key="option.label"></el-option>
          </el-select>
        </div>
      </div>
      <div class="col-md-3">
        <h4 class="card-title text-left">상태</h4>
        <div class="row">
          <el-select class="col-md-12 select-primary" size="large" placeholder="상태" v-model="filterType">
            <el-option v-for="option in filterTypes" class="select-primary" :value="option.value" :label="option.label" :key="option.label"></el-option>
          </el-select>
        </div>
      </div>

      <div class="col-md-3">
        <h4 class="card-title text-left">검색어</h4>
        <div class="row">
          <div class="col-md-12 text-left">
            <base-input placeholder="검색어" v-model="searchWord">
              <span slot="helpBlock" class="form-text" />
            </base-input>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-8">
        <div class="row">
          <div class="col-md-12 text-left">
            <base-button @click="getUsers(1)" type="default">검색</base-button>
          </div>
        </div>
      </div>
      <div class="col-sm-2">
        <div class="row">
          <div class="col-md-12 text-left">
            <base-button @click="addUser" type="default">유저 추가</base-button>
          </div>
        </div>
      </div>
      <div class="col-sm-2">
        <div class="row">
          <div class="col-md-12 text-left">
            <base-button @click="showSubscriptionModal" type="default">구독 부여</base-button>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <el-table :span-method="objectSpanMethod" :data="data" @selection-change="selectionChange">
        <el-table-column :min-width="20" type="selection" :selectable="canSelectRow"></el-table-column>
        <el-table-column v-for="column in tableColumns" :key="column.label" :min-width="column.minWidth" :prop="column.prop" :label="column.label" />
        <el-table-column :min-width="100" align="right" label="팔로우">
          <div slot-scope="props">
            <el-select class="select-primary" size="large" v-model="props.row.followId" v-if="props.row.follows.length > 0">
              <el-option v-for="option in props.row.follows" class="select-primary" :value="option.value" :label="option.label" :key="option.value" />
            </el-select>
          </div>
        </el-table-column>
        <el-table-column v-if="searchedFilter === 2 || searchedFilter === 3" :min-width="100" align="right" label="삭제">
          <div slot-scope="props">
            <base-button @click.native="deleteUserLimit(props.row.userId)" class="icon-simple-delete btn-link" type="warning" size="sm" icon>
              <i class="tim-icons icon-pencil" />
            </base-button>
          </div>
        </el-table-column>
        <el-table-column :min-width="100" align="right" label="상세보기">
          <div slot-scope="props">
            <base-button @click.native="showUserDetail(props.row.userId)" type="warning" size="sm" icon>
              <i class="tim-icons icon-zoom-split" />
            </base-button>
          </div>
        </el-table-column>
      </el-table>
    </div>
    <div class="row">
      <base-pagination class="pagination-no-border" v-model="currentPage" :pageCount="totalPages" />
    </div>
    <UserSubscriptionModal
      :key="componentKey + 1000"
      :userIds="userIds"
      :shouldShow="subscriptionModal.show"
      :onConfirm="onSubscriptionModal"
      :onCancel="onSubscriptionCancelModal"
    ></UserSubscriptionModal>
  </div>
</template>
<script>
import ArtistSelect from "@/pages/Components/ArtistSelect.vue";
import { Table, TableColumn } from "element-ui";
import { BaseInput, BasePagination } from "@/components/index";
import { formatDateTime } from "@/util/DateUtils";
import UserSubscriptionModal from "@/pages/User/UserSubscriptionModal.vue";

export default {
  components: {
    UserSubscriptionModal,
    BaseInput,
    ArtistSelect,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    BasePagination,
  },
  async created() {
    await this.getUsers();
  },
  data() {
    return {
      unitId: null,
      userIds: [],
      tableColumns: [
        {
          prop: "userId",
          label: "유저아이디",
          minWidth: 100,
        },
        {
          prop: "email",
          label: "이메일",
          minWidth: 100,
        },
        {
          prop: "regDate",
          label: "가입일",
          minWidth: 100,
        },
        {
          prop: "isSubscribed",
          label: "구독",
          minWidth: 30,
        },
      ],
      searchType: 1,
      searchOptions: [
        {
          value: 1,
          label: "유저아이디",
        },
        {
          value: 2,
          label: "유저닉네임",
        },
        {
          value: 3,
          label: "이메일",
        },
      ],
      filterType: 0,
      searchedFilter: 0,
      filterTypes: [
        {
          value: 0,
          label: "사용중",
        },
        {
          value: 1,
          label: "탈퇴",
        },
        {
          value: 2,
          label: "이용제재",
        },
        {
          value: 3,
          label: "영구정지",
        },
      ],
      data: [],
      searchWord: null,
      currentPage: 1,
      totalPages: null,
      spanArr: [],
      componentKey: 0,
      subscriptionStartTime: null,
      subscriptionEndTime: null,
      userDetailModal: {
        show: false,
      },
      subscriptionModal: {
        show: false,
      },
    };
  },
  watch: {
    currentPage: {
      handler() {
        this.getUsers(this.currentPage);
      },
    },
    data: {
      handler() {
        this.getSpanArr(this.data);
      },
    },
  },
  methods: {
    async getArtistInfo(param) {
      this.unitId = param.unitId;
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0 || columnIndex === 1 || columnIndex === 2) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
    },
    getSpanArr(data) {
      for (var i = 0; i < data.length; i++) {
        if (i === 0) {
          this.spanArr.push(1);
          this.pos = 0;
        } else {
          if (data[i].userId === data[i - 1].userId) {
            this.spanArr[this.pos] += 1;
            this.spanArr.push(0);
          } else {
            this.spanArr.push(1);
            this.pos = i;
          }
        }
      }
    },
    async getUsers(page) {
      const queryParams = {
        searchWord: this.searchWord,
        searchType: this.searchType,
        filterType: this.filterType,
        unitId: this.unitId,
      };

      const params = { filter: this.filterType, unitId: this.unitId };
      params.currentPage = page ? page : 1;
      if (this.searchType === 1) {
        params.userId = this.searchWord;
      } else if (this.searchType === 2) {
        params.nickname = this.searchWord;
      } else if (this.searchType === 3) {
        params.email = this.searchWord;
      }
      this.spanArr = [];

      const user = await this.$axios.get("/users", { params });
      this.data = user.data.data.map((user) => {
        user.regDate = formatDateTime(user.regTime, "YYYY-MM-DD");
        user.userInfo = `${user.userId}\n(${user?.email})`;
        const nicknames = user?.nickname?.split(",");
        const unitNames = user?.unitName?.split(",");
        const status = user?.state?.split(",");
        user.follows = [];
        for (let i = 0; i < nicknames?.length || 0; i++) {
          user.follows.push({ value: i, label: `${unitNames[i]}  ${nicknames[i]} ${status[i] === "1" ? "O" : "X"}` });
        }
        user.followId = 0;
        user.isSubscribed = user.subscriptionId ? "O" : "X";
        return user;
      });
      this.searchedFilter = this.filterType;
      const pages = await this.$axios.get("/users/pages", { params });
      this.totalPages = Number(pages.data.data);
    },
    async addUser() {
      await this.$router.push(`/user/userDetail`);
    },
    async setBlockedUsers() {
      return this.$axios.put("/users/blocks").then((res) => {
        window.Toast.success("제재 유저 설정 완료");
      });
    },
    async deleteUserLimit(userId) {
      let url = "";
      if (this.searchedFilter === 2) {
        url = `/users/${userId}/block`;
      } else if (this.searchedFilter === 3) {
        url = `/users/${userId}/ban`;
      }

      return this.$axios
        .delete(url)
        .then((res) => {
          window.Toast.success(res.data.data.message);

          this.getUsers();
        })
        .catch((error) => {
          window.Toast.error(error.response.data.error.message);
        });
    },
    showUserDetail(userId) {
      window.open(`/user/userDetail?userId=${userId}`);
    },
    canSelectRow(row, index) {
      return row.isSubscribed === "X";
    },
    selectionChange(rows) {
      this.userIds = rows.map((row) => row.userId);
    },

    showSubscriptionModal() {
      if(!this.userIds?.filter((userId)=> typeof userId === 'string').length) {
        window.Toast.error("유저를 선택해주세요.");
        return
      }
      this.subscriptionModal.show = true;
    },
    onSubscriptionModal() {},
    async onCancelModal() {
      await this.getUsers();
      this.userDetailModal.show = false;
    },
    async onSubscriptionCancelModal() {
      this.subscriptionModal.show = false;
      await this.getUsers();
    },
  },
};
</script>
<style scoped>
tr {
  cursor: pointer;
}
</style>
